import { countryCodes } from '~~/i18n/enums/countryCodes';

/**
 * Markets whose VAT registry publishes company addresses without a postal code. Insisting on one
 * there would leave every company unvalidatable, so the registry address counts as usable without
 * it and the field is simply left unanswered.
 *
 * The customer still has to fill the postal code in on the form - a registry that never states one
 * has nothing to contradict them with, so what they type is taken at face value.
 */
const COUNTRIES_WITHOUT_REGISTRY_POSTAL_CODE: readonly string[] = [countryCodes.LT];

export const isRegistryPostalCodeOptional = (country: string): boolean =>
  COUNTRIES_WITHOUT_REGISTRY_POSTAL_CODE.includes(country.toLowerCase());
